import { screenshotDataURL, showScreenshotModal } from "@/state/recording";
import clsx from "clsx";
import { type FunctionalComponent, createRef } from "preact";
import { useEffect, useState } from "preact/hooks";

const Screenshot: FunctionalComponent = () => {
    const imgRef = createRef<HTMLImageElement>();
    const [show, setShow] = useState(false);

    const close = () => {
        screenshotDataURL.value = null;
        setTimeout(() => {
            // 300 because of the animation duration
            setShow(false);
        }, 300);
    };

    const save = () => {
        const link = document.createElement("a");
        const now = new Date();
        link.download = `StreamCast_${now.getTime()}.webp`;
        link.href = screenshotDataURL.value ?? "";
        link.click();

        setTimeout(() => {
            close();
        }, 200);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <explanation>
    useEffect(() => {
        if (!imgRef.current) return;

        imgRef.current.src = screenshotDataURL.value ?? "";
        if (screenshotDataURL.value) {
            setShow(true);
        }
    }, [screenshotDataURL.value]);

    const onKeyDown = (event: KeyboardEvent) => {
        if (event.key === "s" || event.key === "S") {
            if (!show) return;

            event.stopPropagation();
            save();
        }

        if (event.key === "c" || event.key === "C" || event.key === "Escape") {
            if (!show) return;

            event.stopPropagation();
            close();
        }
    };

    // Register keydown handler
    useEffect(() => {
        window.addEventListener("keydown", onKeyDown);

        return () => {
            window.removeEventListener("keydown", onKeyDown);
        };
    });

    return (
        <>
            <div
                class={clsx(
                    "absolute flex h-full w-full items-center justify-center bg-gray-900 px-64 py-10 opacity-90 transition-opacity duration-300",
                    {
                        hidden: !show,
                        "opacity-90": showScreenshotModal.value,
                        "opacity-0": !showScreenshotModal.value,
                    },
                )}
            >
                <div class="flex w-full flex-col items-center justify-center rounded-xl bg-gray-900 px-10 py-10 text-white">
                    <p class="font-semibold text-white text-xl tracking-wider">Screenshot</p>

                    <img class="mt-4 aspect-video rounded border border-white shadow" alt="screenshot" ref={imgRef} />

                    <div class="mt-10 flex space-x-4">
                        <button
                            type="button"
                            class="w-24 cursor-pointer rounded bg-red-600 px-3 py-2 font-semibold text-white text-xs shadow-xs hover:bg-red-400"
                            onClick={close}
                        >
                            (<span class="text-sm">C</span>)ancel
                        </button>

                        <button
                            type="button"
                            class="w-24 cursor-pointer rounded bg-green-600 px-3 py-2 font-semibold text-white text-xs shadow-xs hover:bg-green-400"
                            onClick={save}
                        >
                            (<span class="text-sm">S</span>)ave
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Screenshot;
